export default {"src":"/_next/static/media/electrode_icon.5550be0f.svg","height":50,"width":6,"blurWidth":0,"blurHeight":0};